export default __webpack_public_path__ + "static/29-cc38e0439fc21283900a65cc18695897.jpg";